export default __webpack_public_path__ + "static/media/covenantofvengeance.d08a0b62.png";